/**
 * Options du swiper du bloc « Accompagnement ».
 *
 * Source unique : ce bloc est instancie par TROIS renderers (page-home, page-offer-details,
 * page-gutenberg). Le fix du 25/08 (retour Amelie : « colonnes tassees », gouttiere portee
 * de 40 — le defaut de WknSwiper — a 70) n'avait ete applique que sur page-gutenberg, donc
 * restait invisible sur les pages rendues en pageOfferDetails et sur la home. Centralise ici
 * pour que les trois ne puissent plus diverger.
 *
 * La gouttiere de 70 ne concerne que le rendu 3 colonnes ; en mobile (carrousel, une carte
 * visible) on garde les 40 d'origine, le retour client demandant au contraire moins d'air.
 * Breakpoint aligne sur $tabletSmall (768px, cf. src/sass/app/require/_var.scss).
 */
export const accompanimentSwiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 40,
  centerInsufficientSlides: true,
  breakpoints: {
    768: { spaceBetween: 70 }
  }
}

export default accompanimentSwiperOptions
